export const getDecodedHtml = ({ html }) => {
    const txtElement = document.createElement('textarea');
    txtElement.innerHTML = html;
    return txtElement.value;
};
//# sourceMappingURL=getDecodedHtml.js.map